"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeToStrHMS = exports.timeToStrHM = exports.ITime = void 0;
var immutable_1 = require("../../immutable");
exports.ITime = (0, immutable_1.IRecord)({
    hours: 0,
    minutes: 0,
    seconds: 0
});
var timeToStrHM = function (time) {
    return time.hours.toString().padStart(2, '0') +
        ':' +
        time.minutes.toString().padStart(2, '0');
};
exports.timeToStrHM = timeToStrHM;
var timeToStrHMS = function (time) {
    return time.hours.toString().padStart(2, '0') +
        ':' +
        time.minutes.toString().padStart(2, '0') +
        ':' +
        time.seconds.toString().padStart(2, '0');
};
exports.timeToStrHMS = timeToStrHMS;
